import * as Types from '../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CreateCommentOldMutationVariables = Types.Exact<{
  poolId: Types.Scalars['ID'];
  questionGroupIds: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
  content: Types.Scalars['String'];
}>;


export type CreateCommentOldMutation = { __typename?: 'Mutation', createComment?: { __typename?: 'CreateCommentPayload', successful: boolean } | null };

export const CreateCommentOldDocument = gql`
    mutation CreateCommentOld($poolId: ID!, $questionGroupIds: [ID!]!, $content: String!) {
  createComment(
    poolId: $poolId
    questionGroupIds: $questionGroupIds
    content: $content
  ) {
    successful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCommentOldGQL extends Apollo.Mutation<CreateCommentOldMutation, CreateCommentOldMutationVariables> {
    document = CreateCommentOldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }